// extracted by mini-css-extract-plugin
export default {"fieldWithUnit":"ConfigModal_fieldWithUnit__p++l3","unit":"ConfigModal_unit__3e9S4"};